module.exports = __webpack_public_path__ + "static/img/logo_q@4x.f30e330.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo_q@4x.png
// module id = Qy8C
// module chunks = 2